const MeaDetailCard = ({ children }) => {
  return <div className="bg-white p-3 flex-1">{children}</div>;
};
export default MeaDetailCard;
